import React, { useEffect, useState } from "react";
import { Modal, Button, Select, Slider, Input, Row, Col, DatePicker } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import "../../css/poolingFilterModal.css";
import closeIcon from "../../assets/icons/pooling/close.svg";
import requestSurplusIcon from "../../assets/icons/pooling/request-surplus.svg";
import requestDeficitIcon from "../../assets/icons/pooling/request-deficit.svg";
import shipIcon from "../../assets/icons/pooling/ship.svg";
import { useDispatch, useSelector } from "react-redux";
import { suggestionFilter,filterSurplusPooling,filterDeficitPooling } from "../../features/Pooling/PoolingSlice";
import dayjs from "dayjs";

const FilterModal = ({ filterType, setSurplusFilters, setDeficitFilters,year,setYear,surplusFilters,deficitFilters,setRedContainer,setGreenContainer, onClose }) => {
  const dispatch = useDispatch();
  const { filterSurplusValues,filterDeficitValues,shipOwners,IMOnumbers } = useSelector((state) => state.pooling);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const currentYear = dayjs().startOf('year').year();

  console.log("filterSurplusValues",filterSurplusValues,filterDeficitValues)

  const dropdown2Options = shipOwners;
  let dropdown4Options = IMOnumbers;
  const initialSliderValue = [0, 99999999999]; // Default slider range
  const initialSlider1Value = [0, 640]; // Default slider range 

  useEffect(()=>{
    if(filterType=="surplus"){
      if(year.surplus){
        dispatch(suggestionFilter({request_type:filterType,year:year.surplus?.year()}));
      }
    }
    if(filterType=="deficit"){
      if(year.deficit){
        dispatch(suggestionFilter({request_type:filterType,year:year.deficit?.year()}));
      }
    }
  },[])

  useEffect(() => {
    setSurplusFilterValues({
      request_type: filterType,
      imo_number: filterSurplusValues[0]?.request_type === filterType ? filterSurplusValues[0]?.imo_number : "",
      ship_owner: filterSurplusValues[0]?.request_type === filterType ? filterSurplusValues[0]?.ship_owner : "",
      compliance_balance_lv: filterSurplusValues[0]?.request_type === filterType
        ? filterSurplusValues[0]?.compliance_balance_lv
        : initialSliderValue[0],
      compliance_balance_uv: filterSurplusValues[0]?.request_type === filterType
        ? filterSurplusValues[0]?.compliance_balance_uv 
        : initialSliderValue[1],
      expected_price_lv: filterSurplusValues[0]?.request_type === filterType  
        ? filterSurplusValues[0]?.expected_price_lv 
        : initialSlider1Value[0],
      expected_price_uv: filterSurplusValues[0]?.request_type === filterType  
        ? filterSurplusValues[0]?.expected_price_uv 
        : initialSlider1Value[1],
      year: year.surplus?.year(),
    });

    setDeficitFilterValues({
      request_type: filterType,
      imo_number: filterDeficitValues[0]?.request_type === filterType ? filterDeficitValues[0]?.imo_number : "",
      ship_owner: filterDeficitValues[0]?.request_type === filterType ? filterDeficitValues[0]?.ship_owner : "",
      compliance_balance_lv: filterDeficitValues[0]?.request_type === filterType 
        ? filterDeficitValues[0]?.compliance_balance_lv
        : initialSliderValue[0],
      compliance_balance_uv: filterDeficitValues[0]?.request_type === filterType 
        ? filterDeficitValues[0]?.compliance_balance_uv 
        : initialSliderValue[1],
      expected_price_lv: filterDeficitValues[0]?.request_type === filterType
        ? filterDeficitValues[0]?.expected_price_lv 
        : initialSlider1Value[0],
      expected_price_uv: filterDeficitValues[0]?.request_type === filterType
        ? filterDeficitValues[0]?.expected_price_uv 
        : initialSlider1Value[1],
      year: year.deficit?.year(),
      
    });
  }, [IMOnumbers, dispatch, filterSurplusValues, filterDeficitValues]);


  const [surplusFilterValues, setSurplusFilterValues] = useState({
    request_type: filterType,
    imo_number: filterSurplusValues[0]?.request_type === filterType ? filterSurplusValues[0]?.imo_number : "",
    ship_owner: filterSurplusValues[0]?.request_type === filterType ? filterSurplusValues[0]?.ship_owner : "",
    compliance_balance_lv: filterSurplusValues[0]?.request_type === filterType 
      ? filterSurplusValues[0]?.compliance_balance_lv
      : initialSliderValue[0],
    compliance_balance_uv: filterSurplusValues[0]?.request_type === filterType
      ? filterSurplusValues[0]?.compliance_balance_uv 
      : initialSliderValue[1],
    expected_price_lv: filterSurplusValues[0]?.request_type === filterType
      ? filterSurplusValues[0]?.expected_price_lv 
      : initialSlider1Value[0],
    expected_price_uv: filterSurplusValues[0]?.request_type === filterType
      ? filterSurplusValues[0]?.expected_price_uv 
      : initialSlider1Value[1],
    year: year.surplus?.year(),
  });
  console.log("filterSurplusValues",filterSurplusValues)
  const [deficitFilterValues, setDeficitFilterValues] = useState({
    request_type: filterType,
    imo_number: filterDeficitValues[0]?.request_type === filterType ? filterDeficitValues[0]?.imo_number : "",
    ship_owner: filterDeficitValues[0]?.request_type === filterType ? filterDeficitValues[0]?.ship_owner : "",
    compliance_balance_lv: filterDeficitValues[0]?.request_type === filterType 
      ? filterDeficitValues[0]?.compliance_balance_lv
      : initialSliderValue[0],
    compliance_balance_uv: filterDeficitValues[0]?.request_type === filterType
      ? filterDeficitValues[0]?.compliance_balance_uv 
      : initialSliderValue[1],
    expected_price_lv: filterDeficitValues[0]?.request_type === filterType
      ? filterDeficitValues[0]?.expected_price_lv 
      : initialSlider1Value[0],
    expected_price_uv: filterDeficitValues[0]?.request_type === filterType 
      ? filterDeficitValues[0]?.expected_price_uv 
      : initialSlider1Value[1],
    year: year.deficit?.year(),
  });
  

  const [dropdownOpen, setDropdownOpen] = useState({
    request_type: false,
    ship_owner: false,
    imo_number: false,
  });

  // Reset Filters to defaults
  const resetFilters = async () => {
    setIsButtonDisabled(true); 
    Modal.confirm({
      title: "Are you sure you want to reset the filters?",
      content: "This will reset all the filter settings to their default values.",
      okText: "Yes, reset",
      cancelText: "Cancel",
      onCancel: ()=> {setIsButtonDisabled(false)},
      onOk: async () => {
        const resetFilterValues = {
          request_type: "",
          imo_number: "",
          ship_owner: "",
          compliance_balance_lv: initialSliderValue[0],
          compliance_balance_uv: initialSliderValue[1],
          expected_price_lv: initialSlider1Value[0],
          expected_price_uv: initialSlider1Value[1],
          year: {
            surplus: filterType === 'surplus' ? year.surplus : year.surplus,
            deficit: filterType === 'deficit' ? year.deficit : year.deficit
          },
        };


        if (filterType === 'surplus') {
          setSurplusFilters(resetFilterValues);
          await dispatch(filterSurplusPooling({year: dayjs().startOf('year').year()}));
          await dispatch(suggestionFilter({request_type:filterType}));
          setYear((prev)=>({
            ...prev,
            surplus:dayjs().startOf('year'),
          }))
          // setGreenContainer([]);
        } else if (filterType === 'deficit') {
          setDeficitFilters(resetFilterValues);
          await dispatch(filterDeficitPooling({year: dayjs().startOf('year').year()}));
          await dispatch(suggestionFilter({request_type:filterType}));

          setYear((prev)=>({
            ...prev,
            deficit:dayjs().startOf('year'),
          }))
          // setRedContainer([]);
        }
        setIsButtonDisabled(false);
      }
    }); 

  };
  

  const handleSelectChange = async (value, filterName) => {
    // Update specific filter logic for 'ship_owner'
    if (filterName === "ship_owner") {
      await dispatch(suggestionFilter({ ship_owner: value,year:year[filterType].year(), request_type: filterType }));
    }
  
    // Choose the appropriate state updater based on filterType
    const setFilterFunction = filterType === "surplus" ? setSurplusFilterValues : setDeficitFilterValues;
  
    // Update the specific filter values
    setFilterFunction((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  
    // Toggle the dropdown state
    setDropdownOpen((prev) => ({
      ...prev,
      [filterName]: false, // Close the dropdown after selection
    }));
  };
  
  

  // Handle slider value changes for compliance balance
  const handleComplianceBalanceChange = (value, type) => {
    if (filterType === "surplus") {
      setSurplusFilterValues((prev) => ({
        ...prev,
        [`${type}_lv`]: value[0] !== undefined ? value[0] : prev[`${type}_lv`], // Update if value[0] exists
        [`${type}_uv`]: value[1] !== undefined ? value[1] : prev[`${type}_uv`], // Update if value[1] exists
      }));
    } else {
      setDeficitFilterValues((prev) => ({
        ...prev,
        [`${type}_lv`]: value[0] !== undefined ? value[0] : prev[`${type}_lv`],
        [`${type}_uv`]: value[1] !== undefined ? value[1] : prev[`${type}_uv`],
      }));
    }
  };
  
  

// Handle slider value changes for expected price
const handleExpectedPriceSliderChange = (value, type) => {
  console.log("value, type",value, type)
  if (filterType === "surplus") {
    setSurplusFilterValues((prev) => ({
      ...prev,
      [`${type}_lv`]: value[0] !== undefined ? value[0] : prev[`${type}_lv`], // Update if value[0] exists
      [`${type}_uv`]: value[1] !== undefined ? value[1] : prev[`${type}_uv`], // Update if value[1] exists
    }));
  } else {
    setDeficitFilterValues((prev) => ({
      ...prev,
      [`${type}_lv`]: value[0] !== undefined ? value[0] : prev[`${type}_lv`],
      [`${type}_uv`]: value[1] !== undefined ? value[1] : prev[`${type}_uv`],
    }));
  }
};

const handleInputChange = (e, fieldType, boundary) => {
  const value = e.target.value;

  // Allow empty string or valid numbers (including decimals like 1890.0)
  if (value === "" || /^[0-9]+(\.[0-9]*)?$/.test(value)) {
    const updatedValue = value === "" ? "" : value; // Keep as string for precision like "1890.0"
    const parsedValue = value === "" ? "" : parseFloat(value); // Convert to number only when necessary

    if (filterType === "surplus") {
      setSurplusFilterValues((prev) => ({
        ...prev,
        [`${fieldType}`]: boundary === "lv" ? updatedValue : prev[`${fieldType}`],
        [`${fieldType.replace('_lv', '_uv')}`]: boundary === "uv" ? updatedValue : prev[`${fieldType.replace('_lv', '_uv')}`]
      }));

      // Update slider only if both values are valid numbers
      if (parsedValue !== "" && !isNaN(parsedValue)) {
        const currentValues = [
          boundary === "lv" ? parsedValue : parseFloat(surplusFilterValues[`${fieldType}`] || "0"),
          boundary === "uv" ? parsedValue : parseFloat(surplusFilterValues[`${fieldType.replace('_lv', '_uv')}`] || "0")
        ];
        handleComplianceBalanceChange(currentValues, fieldType.split('_')[0]);
      }
    } else {
      setDeficitFilterValues((prev) => ({
        ...prev,
        [`${fieldType}`]: boundary === "lv" ? updatedValue : prev[`${fieldType}`],
        [`${fieldType.replace('_lv', '_uv')}`]: boundary === "uv" ? updatedValue : prev[`${fieldType.replace('_lv', '_uv')}`]
      }));

      // Update slider only if both values are valid numbers
      if (parsedValue !== "" && !isNaN(parsedValue)) {
        const currentValues = [
          boundary === "lv" ? parsedValue : parseFloat(deficitFilterValues[`${fieldType}`] || "0"),
          boundary === "uv" ? parsedValue : parseFloat(deficitFilterValues[`${fieldType.replace('_lv', '_uv')}`] || "0")
        ];
        handleComplianceBalanceChange(currentValues, fieldType.split('_')[0]);
      }
    }
  }
};

const handleYearChange = (value) => {
  console.log("value",value)

  const year = value;
  const field = "year"; 

  if(filterType === "surplus" && field=="year"){
    setYear((prev)=>({
      ...prev,
      surplus: year
    }));
  }
  else if (filterType === "deficit" && field=="year") {
    setYear((prev)=>({
      ...prev,
      deficit: year
    }));
  } else {
    setYear((prev)=>({
      ...prev,
      surplus: null,
      deficit: null
    }));
  }
  

  if (filterType === "surplus") {
    setSurplusFilterValues((prev) => ({
      ...prev,
      [field]: year,
    }));
    dispatch(suggestionFilter({request_type:filterType,year:year.year()}));
  } else {
    setDeficitFilterValues((prev) => ({
      ...prev,
      [field]: year,
    }));
    dispatch(suggestionFilter({request_type:filterType,year:year.year()}));
  }

};




  const handleApplyFilters = () => {
    // Define the formatted filters based on filterType
    const formattedFilters =
      filterType === 'surplus'
        ? {
            ...surplusFilterValues
          }
        : {
            ...deficitFilterValues
          };
  
    // Use the appropriate setter based on filterType
    if (filterType === 'surplus') {
      setSurplusFilters(formattedFilters);
    } else if (filterType === 'deficit') {
      setDeficitFilters(formattedFilters);
    }
  
    onClose(); // Close the modal
  };
  
  

  // Handle dropdown open/close
  const toggleDropdown = (dropdown) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [dropdown]: !prev[dropdown],
    }));
  };

  return (
    <div className="fixed-filter-modal">
      <div className="filter-modal-header">
        <div className="filter-modal-header-left">
          <h3>Apply Filters</h3>
          <p className="filter-modal-subheader">
            Customize the vessels displayed on the pooling screen.
          </p>
        </div>
        <div className="filter-modal-header-right">
          <Button className="close-button" onClick={onClose}>
            <img src={closeIcon} alt="close" />
          </Button>
        </div>
      </div>
      <div className="filter-divider-line"></div>
      <div className="filter-modal-body">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div className="select-title">Request Type</div>
            <Select
              className={filterType === "surplus" ? "surplus-filter" : "deficit-filter"}
              value={filterType.charAt(0).toUpperCase() + filterType.slice(1)}
              onChange={(value) => handleSelectChange(value, "request_type")}
              onDropdownVisibleChange={() => toggleDropdown("request_type")}
              suffixIcon={
                dropdownOpen.request_type ? (
                  <>
                    <img
                      src={filterType === "surplus" ? requestSurplusIcon : requestDeficitIcon}
                      alt="filter icon"
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={filterType === "surplus" ? requestSurplusIcon : requestDeficitIcon}
                      alt="filter icon"
                    />
                  </>
                )
              }
              style={{ width: "100%" }}
              disabled={true}
            >
              <Select.Option key={filterType} value={filterType}>
                {filterType.charAt(0).toUpperCase() + filterType.slice(1)}
              </Select.Option>
            </Select>
          </Col>
          <Col span={24}>
            <div className="select-title">Year</div>
            <DatePicker
              picker="year"
              style={{width:"100%"}}
              value={filterType=="surplus" ? year.surplus : year.deficit}
              defaultValue={filterType=="surplus" ? year.surplus : year.deficit}
              onChange={handleYearChange}
              format="YYYY"
              allowClear={false}
            />
            
          </Col>
          <Col span={24}>
            <div className="select-title">Ship Owner</div>
            <Select
              value={filterType === "surplus" ? surplusFilterValues.ship_owner : deficitFilterValues.ship_owner}
              onChange={(value) => handleSelectChange(value, "ship_owner")}
              onDropdownVisibleChange={() => toggleDropdown("ship_owner")}
              placeholder="Select Owner"
              showSearch
              suffixIcon={
                dropdownOpen.ship_owner ? (
                  <>
                    <img src={shipIcon} alt="ship icon" />
                    <UpOutlined />
                  </>
                ) : (
                  <>
                    <img src={shipIcon} alt="ship icon" />
                    <DownOutlined />
                  </>
                )
              }
              style={{ width: "100%" }}
              filterOption={(input, option) => 
                option.children.toLowerCase().includes(input.toLowerCase())  // Custom search logic
              }
            >
              {dropdown2Options?.slice().sort((a, b) => a.localeCompare(b)).map((option) => (
                <Select.Option key={option} value={option}>
                  {option}
                </Select.Option>
              ))}
            </Select>
          </Col>
          {(filterType === "surplus" ? surplusFilterValues.ship_owner : deficitFilterValues.ship_owner) && (
            <>
              <Col span={24}>
                <div className="select-title">IMO Number</div>
                <Select
                  value={filterType === "surplus" ? surplusFilterValues.imo_number : deficitFilterValues.imo_number}
                  onChange={(value) => handleSelectChange(value, "imo_number")}
                  onDropdownVisibleChange={() => toggleDropdown("imo_number")}
                  placeholder="Select IMO Number"
                  suffixIcon={dropdownOpen.imo_number ? <UpOutlined /> : <DownOutlined />}
                  style={{ width: "100%" }}
                  showSearch  // Enable search functionality
                  filterOption={(input, option) => 
                    option.children.toLowerCase().includes(input.toLowerCase())  // Custom search logic
                  }
                >
                  {dropdown4Options?.slice().sort((a, b) => a.localeCompare(b)).map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Col>
            </>
            )}
              <Col span={24}>
                <div className="select-title">Compliance Balance (MT CO<sub>2</sub>e)</div>
                <Slider
                  range
                  min={0}
                  max={99999999999}
                  value={filterType === "surplus" ?
                    [
                      surplusFilterValues.compliance_balance_lv, 
                      surplusFilterValues.compliance_balance_uv
                    ]
                    :
                    [
                      deficitFilterValues.compliance_balance_lv, 
                      deficitFilterValues.compliance_balance_uv
                    ]
                  }
                  onChange={(e) => handleComplianceBalanceChange(e, "compliance_balance")}
                  style={{ width: "80%" }}
                />
                <Row
                  gutter={8}
                  style={{
                    marginTop: 10,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Col span={10}>
                    <Input
                      type="number"
                      value={filterType === "surplus" ? surplusFilterValues.compliance_balance_lv : deficitFilterValues.compliance_balance_lv}
                      onChange={(e) => handleInputChange(e, "compliance_balance_lv", "lv")}
                    />
                  </Col>
                  <Col
                    span={1}
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    -
                  </Col>
                  <Col span={10}>
                    <Input
                      type="number"
                      value={filterType === "surplus" ? surplusFilterValues.compliance_balance_uv : deficitFilterValues.compliance_balance_uv}
                      onChange={(e) => handleInputChange(e, "compliance_balance_uv", "uv")}
                    />
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <div className="select-title">Expected Price (€/MT CO<sub>2</sub>e)</div>
                <Slider
                  range
                  min={0}
                  max={640}
                  step={20}
                  value={
                    filterType === "surplus"
                      ? [surplusFilterValues.expected_price_lv,surplusFilterValues.expected_price_uv]
                      : [deficitFilterValues.expected_price_lv,deficitFilterValues.expected_price_uv]

                  }
                  onChange={(e) => handleExpectedPriceSliderChange(e, "expected_price")}
                  style={{ width: "80%" }}
                />
                <Row gutter={8} style={{ marginTop: 10, display: "flex", alignItems: "center" }}>
                  <Col span={10}>
                    <Input
                      type="number"
                      value={
                        filterType === "surplus"
                          ? surplusFilterValues.expected_price_lv
                          : deficitFilterValues.expected_price_lv
                      }
                      onChange={(e) => handleInputChange(e, "expected_price_lv", "lv")}
                    />
                  </Col>
                  <Col
                    span={1}
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    -
                  </Col>
                  <Col span={10}>
                    <Input
                      type="number"
                      value={
                        filterType === "surplus"
                          ? surplusFilterValues.expected_price_uv
                          : deficitFilterValues.expected_price_uv
                      }
                      onChange={(e) => handleInputChange(e, "expected_price_uv", "uv")}
                    />
                  </Col>
                </Row>
              </Col>

            
          
        </Row>
      </div>
      <div className="filter-modal-footer">
        <Button className="reset-button" disabled={isButtonDisabled} oncanc onClick={resetFilters}>
          Reset
        </Button>
        <Button 
          className="apply-button" 
          type="primary" 
          onClick={handleApplyFilters}
        >
          Apply
        </Button>
      </div>
    </div>
  );  
};

export default FilterModal;
